import { Autocomplete, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import StickyTable from './BotConfigTab';
import { fetcBotQuestions, getAllLanguage } from '../../shared/ApiEndpoint';
import axiosInstance from '../../../utils/axiosInstance';

const LanguageConfig = ({botId,bots_type}) => {
  const [languagesList,setlanguagesList]= useState([])
  const [selectedLanguages, setSelectedLanguages] = useState([]);
   const [translations, setTranslations] = useState({});
useEffect(()=>{
    getAllLng();
},[])
  useEffect(()=>{
    fetchQuestionByBotId(botId)
  },[botId])


  const getAllLng=async()=>{
    const resp = await axiosInstance.get(getAllLanguage,{withCredentials:true})
    if(resp.status===200){
        const result= resp?.data?.data.map(lang=>({
            id:lang?._id,
            language:lang?.language,
            code:lang?.language_code
        }));
       setlanguagesList(result);
    }
  }

  const fetchQuestionByBotId=async(bot_id)=>{
    try {
        const resp = await axiosInstance.get(`${fetcBotQuestions}/${bot_id}`,{
          params: { bots_type },
          withCredentials:true})
    if (resp.status===200){
        const selectedLang= resp.data.selectedLanguages
        setTranslations(resp?.data?.questions)
        setSelectedLanguages(selectedLang)
    }
    } catch (error) {
        console.log(error)
    }
  }

  return (
    <>
      <div className='pb-4'>
        <Autocomplete
          multiple
          options={languagesList}
          getOptionLabel={(option) => option.language}
          value={languagesList.filter(lang => selectedLanguages.includes(lang.code))}
          onChange={(event, newValue) => {
            const selectedIds = newValue.map(item => item.code);
            setSelectedLanguages(selectedIds);
          }}
          disableClearable
          renderInput={(params) => (
            <TextField {...params} label="Select Languages" placeholder="Languages" />
          )}
          isOptionEqualToValue={(option, value) => option.code === value.code}
        />
      </div>
      <StickyTable selectedLanguages={selectedLanguages} languagesList={languagesList}  botId={botId} translations={translations} setTranslations={setTranslations} bots_type={bots_type}/>
    </>
  );
};

export default LanguageConfig;
